import { CustomFieldWithError } from "./CustomFieldWithError";
import { ReactComponent as HideIcon } from "../../assets/hide.svg";
import { ReactComponent as ShowIcon } from "../../assets/show.svg";
import { useState } from "react";
import { Field } from "formik";

export function Password({
  error,
  touched,
  id,
  name,
}: {
  error: string | null;
  touched?: boolean;
  id?: string;
  name?: string;
}) {
  const [showPassword, setShowPassoword] = useState(false);

  return (
    <>
      <div className="relative">
        <Field
          className={`border px-2 rounded w-full h-10 mt-0 ${
            error ? "border-red-500" : ""
          }`}
          type={showPassword ? "text" : "password"}
          id={`${id}`}
          name={`${name}`}
          error={error}
          touched={touched}
        />
        <div
          className="absolute right-0 top-0 cursor-pointer h-full translate-x-[-10px]"
          onClick={() => setShowPassoword(!showPassword)}
        >
          <div className="flex h-full items-center">
            {showPassword ? <HideIcon /> : <ShowIcon />}
          </div>
        </div>
      </div>
      {error && touched ? (
        <div className="text-sm text-red-500">{error}</div>
      ) : null}
    </>
  );
}
